import React, { useState } from "react"
import CancellationReasonDialog from "./reason-dialog"
import PriceDialog from "./price-dialog"
import TechnicalSupportDialog from "./support-dialog"
import FeedbackDialog from "./feedback-dialog"
import ConfirmCancellationDialog from "./confirm-dialog"
import SuccessDialog from "./success-dialog"
import StoreCancellationDialog from "./StoreCancellationDialog"

const CancellationFlow = ({ isOpen, onClose, subscription }) => {
  const [step, setStep] = useState("reason")
  const [feedback, setFeedback] = useState("")
  const [reason, setReason] = useState(null)
  const [storeDialogOpen, setStoreDialogOpen] = useState(false)
  const [storeInfo, setStoreInfo] = useState(null)

  const handleClose = () => {
    setStep("reason")
    setReason(null)
    setFeedback("")
    onClose()
  }

  const flow = [
    {
      id: "reason",
      Component: CancellationReasonDialog,
      props: {
        isOpen,
        onClose: handleClose,
        subscription,
        onNext: (selectedReason) => {
          setReason(selectedReason)
          switch (selectedReason) {
            case "price":
              setStep("price")
              break
            case "technical":
              setStep("technical")
              break
            default:
              setStep("feedback")
          }
        },
      },
    },
    {
      id: "price",
      Component: PriceDialog,
      props: {
        isOpen,
        onClose: handleClose,
        onContinue: () => setStep("confirm"),
      },
    },
    {
      id: "technical",
      Component: TechnicalSupportDialog,
      props: {
        isOpen,
        onClose: handleClose,
        onContinue: () => setStep("confirm"),
      },
    },
    {
      id: "feedback",
      Component: FeedbackDialog,
      props: {
        isOpen,
        onClose: handleClose,
        onContinue: (feedbackText) => {
          setFeedback(feedbackText)
          setStep("confirm")
        },
      },
    },
    {
      id: "confirm",
      Component: ConfirmCancellationDialog,
      props: {
        isOpen,
        onClose: handleClose,
        subscription,
        reason,
        feedback,
        onConfirm: () => setStep("success"),
        onShowStoreDialog: (storeData) => {
          setStoreInfo(storeData)
          setStoreDialogOpen(true)
        },
      },
    },
    {
      id: "success",
      Component: SuccessDialog,
      props: {
        isOpen,
        onClose: handleClose,
      },
    },
  ]

  const currentStep = flow.find((s) => s.id === step)

  if (!currentStep) return null

  const { Component, props } = currentStep
  return (
    <>
      <Component {...props} />
      <StoreCancellationDialog
        isOpen={storeDialogOpen}
        onClose={() => {
          setStoreDialogOpen(false)
          setStoreInfo(null)
        }}
        storeInfo={storeInfo}
      />
    </>
  )
}

export default CancellationFlow
